import { usePermissions } from './PermissionContext';

/** Whether the user may see/edit party, broker, transport, price and order financial documents. */
export function useCommercialAccess() {
  const { can, ownerAdmin } = usePermissions();
  return ownerAdmin || can('ORDERS', 'VIEW_COMMERCIAL_DATA');
}
